import styled from 'styled-components';
import Container from '../Base/style';

export default styled(Container)`
${({ theme }) => `
background-color: ${theme.colors.HEADER_COLOR} !important;
color: ${theme.colors.FOOTER_HEADING} !important;
`}
`;
